export default "__VITE_ASSET__IaTNNiIA__"